import { FormattedMessage, useIntl } from "react-intl";
import { useMsal } from "@azure/msal-react";

import { PageLayout } from "../../common/page-layout/page-layout";

export const Welcome = () => {
  const intl = useIntl();
  const { accounts } = useMsal();

  return (
    <PageLayout title={intl.formatMessage({ id: "page.welcome.title" })}>
      <>
        <h1>
          <FormattedMessage
            id="page.welcome.welcome"
            values={{ name: accounts[0].name }}
          />
        </h1>
        <p>
          <FormattedMessage id="page.welcome.description" />
        </p>
      </>
    </PageLayout>
  );
};
